import { useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import useAuth from "src/hooks/useAuth";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";
import v2_actionListSectorsByClient from "src/actions/v2/cliente/v2_actionListSectorsByClient";
import { Switch } from "src/@/components/ui/switch";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";
import { RowInput } from "src/components/forms/RowInput";

const ChatAssign = ({
  user,
  actionPhase,
  actionState,
  changeActionState
}) => {
  const { cliente } = useAuth();
  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [canais, setCanais] = useState([]);

  let usersFormatted = users?.map((user) => {
    return {
      value: user._id,
      label: user.nomeFantasia
    }
  });

  let departmentsFormatted = departments?.map((department) => {
    return {
      value: department._id,
      label: department.nome_setor
    }
  });

  let canaisFormatted = canais?.map((canal) => {
    return {
      value: canal.cliente_id || canal.clienteId,
      label: canal.nome
    }
  });

  async function getUsers() {
    try {
      const response = await getActionListaUsuariosByClienteId(user?.clienteId);
      setUsers(response.data.usuarios);

    } catch (error) {
      console.log(error);
    }
  }


  async function getListSectors() {
    try {
      const response = await v2_actionListSectorsByClient(user?.clienteId);
      setDepartments(response.data.data)
    } catch (error) {
      console.log(error);
    }
  }

  async function buscarListaCanais() {
    try {
      const response = await actionListaCanaisPorCliente(cliente._id);
      setCanais(response.data.data || []);
    } catch (error) {
      console.error("Erro ao buscar lista de canais:", error);
    }
  }


  useEffect(() => {
    getUsers();
    getListSectors();
    buscarListaCanais();
  }, []);



  return (
    <Card className="w-full">
      <CardHeader>
        <LabelFromAction>
          {actionPhase.name}
        </LabelFromAction>
      </CardHeader>
      <CardContent>
        <div className="space-y-4 flex flex-col gap-2">
          <RowInput
            isRequired={true}
            label="Canal"
            info={"Canais que estão atrelados ao chat"}
            input={
              <MultiSelect
                options={canaisFormatted}
                onValueChange={(e) =>
                  changeActionState({ name: "chatChannels", value: e })
                }
                defaultValue={actionState.chatChannels}
                placeholder="Selecionar canais"
                variant="inverted"
                animation={2}
                maxCount={3}
              />
            }
          />
          <div>
            <label className="block text-sm font-medium">Usuários</label>
            <MultiSelect
              options={usersFormatted}
              onValueChange={(e) => {
                let event = {
                  name: "chatUsersAssign",
                  value: e
                }
                changeActionState(event);
              }}
              defaultValue={actionState?.chatUsersAssign}
              placeholder="Selecionar usuarios"
              variant="inverted"
              animation={2}
              maxCount={3}
            />
          </div>


          <div>
            <label className="block text-sm font-medium">Setores</label>

            <MultiSelect
              options={departmentsFormatted}
              onValueChange={(e) => {
                let event = {
                  name: "chatDepartamentsAssign",
                  value: e
                }
                changeActionState(event);
              }}
              defaultValue={actionState?.chatDepartamentsAssign}
              placeholder="Selecionar setores"
              variant="inverted"
              animation={2}
              maxCount={3}
            />
          </div>

          <AutomationOnlyExecute
            actionState={actionState}
            changeActionState={changeActionState}
          />

        </div>
      </CardContent>
    </Card>
  );
};

export default ChatAssign;
